import { Center, Group, Table } from '@mantine/core';
import { FC } from 'react';
import { APIPropertyItemFunction } from '@mygpt/app';
import ActionMenu from '@/components/ActionMenu';

interface ApiItemProps {
  item: APIPropertyItemFunction;
  index: number;
  selected?: boolean;
  onSelectedChange?: (selected: boolean) => void;
  onDelete?: (faqs: APIPropertyItemFunction) => void;
  onEdit?: (faqs: APIPropertyItemFunction) => void;
}

const ApiItem: FC<ApiItemProps> = ({ index, item, onDelete, onEdit, onSelectedChange, selected }) => {
  return (
    <Table.Tr
      className="cursor-pointer"
      onClick={() => {
        onSelectedChange?.(!selected);
      }}
    >
      <Table.Td>
        <Group wrap="nowrap" gap="xs">
          {/* <Checkbox checked={selected} /> */}
          <span className="text-left">{index}</span>
        </Group>
      </Table.Td>
      <Table.Td>
        <span className="text-left">{item.function_call_name}</span>
      </Table.Td>
      <Table.Td>
        <span className="text-left">{item.function_call_description}</span>
      </Table.Td>
      <Table.Td>{item.method}</Table.Td>
      <Table.Td>
        {item.server_url}
        {item.path}
      </Table.Td>
      <Table.Td>
        <Center>
          <ActionMenu onEdit={() => onEdit?.(item)} onDelete={() => onDelete?.(item)} />
        </Center>
      </Table.Td>
    </Table.Tr>
  );
};

export default ApiItem;
